<template>
  <CelusAlert type="error">
    <slot />
  </CelusAlert>
</template>

<script setup lang="ts">
import CelusAlert from "@/components/util/CelusAlert.vue";

defineOptions({
  name: "CelusErrorAlert",
});
</script>
